"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = exports.withAppContext = exports.AppConsumer = exports.AppProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useAppState = _interopRequireDefault(require("../hooks/useAppState"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var initialState = {
  asset: {
    asset: undefined,
    setAsset: function setAsset() {}
  },
  assetData: {},
  analyticsData: null,
  analyticsDebounce: 5000,
  annotationsEnabled: false,
  annotationsCreationEnabled: true,
  annotationsMultiPageEnabled: false,
  annotationTypes: null,
  authenticateFetch: true,
  backgroundModeEnabled: false,
  peopleGraphAPIKey: null,
  cacheComments: false,
  disableCCXWorkflow: false,
  disableCommentCreation: false,
  disableNetworkIndicator: false,
  environment: 'stage',
  filterComments: true,
  globalComments: false,
  globalCommentsUnmapped: false,
  globalCommentsToggle: {
    isActive: false,
    onToggle: function onToggle() {}
  },
  hasReviewAccess: true,
  imageCapture: false,
  imageContextData: {},
  imsData: {},
  inContextCommentingEnabled: false,
  isMapping: false,
  isLoading: false,
  invitationServiceAccessToken: undefined,
  locale: 'en-US',
  localeStringOverrides: {},
  mentionsEnabled: false,
  shareStatus: 'unshared',
  reCaptchaSiteKey: '',
  typekitId: 'pwg1jsp',
  reCaptchaEnabled: true,
  compactLayout: false,
  touchControls: false,
  theme: 'light',
  spectrumUIScale: 'medium',
  reviewType: 'artifact',
  richTextEntry: true
};
exports.initialState = initialState;

var AppContext = /*#__PURE__*/_react.default.createContext(initialState);

var Provider = AppContext.Provider,
    AppConsumer = AppContext.Consumer;
exports.AppConsumer = AppConsumer;

var withAppContext = function withAppContext(WrappedComponent) {
  var WithAppContext = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
    return /*#__PURE__*/_react.default.createElement(AppConsumer, null, function (contextValues) {
      return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({}, contextValues, props, {
        ref: ref
      }));
    });
  });

  var displayName = "".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ".Wrapped");
  WithAppContext.displayName = "WithAppContext(".concat(displayName, ")");
  return WithAppContext;
};

exports.withAppContext = withAppContext;

var AppProvider = function AppProvider(props) {
  var appContext = (0, _useAppState.default)(props);
  return /*#__PURE__*/_react.default.createElement(Provider, {
    value: appContext
  }, props.children);
};

exports.AppProvider = AppProvider;
AppProvider.defaultProps = initialState;
AppProvider.propTypes = {
  children: _propTypes.default.node
};
var _default = AppContext;
exports.default = _default;